import { Button, FormField, Modal, TextArea, TextInput } from '@neshane/blueberry';
import { useState } from 'react';

/**
 * Create / view / edit terms version modal.
 *
 * When `version` is provided the modal opens in view mode (content editable
 * for admins); "ذخیره تغییرات" calls `onSubmit`. When `version` is null it
 * creates a brand new version that becomes active immediately.
 */
export const TermsFormModal = ({
    version,
    isSubmitting,
    onSubmit,
    onCancel,
}) => {
    const isEdit = Boolean(version);
    const [title, setTitle] = useState(version?.title || '');
    const [content, setContent] = useState(version?.content || '');
    const [localError, setLocalError] = useState('');

    const canSubmit = title.trim().length > 0 && content.trim().length > 0;

    const handleSubmit = async () => {
        if (!canSubmit) {
            setLocalError('عنوان و متن قوانین را کامل کنید');
            return;
        }
        setLocalError('');
        await onSubmit({ title, content });
    };

    return (
        <Modal
            isOpen
            onClose={onCancel}
            iconName="document-duplicate"
            iconVariant="info"
            title={isEdit ? `نسخه ${version.version} قوانین` : 'ایجاد نسخه جدید قوانین'}
            subtitle={isEdit ? 'ویرایش محتویات قوانین و مقررات' : 'نسخه جدید قوانین بلافاصله به‌عنوان نسخه فعال ثبت می‌شود'}
            actions={[
                <Button
                    key="onCancel"
                    variant="secondaryNeutral"
                    text="انصراف"
                    isDisabled={isSubmitting}
                    onClick={onCancel}
                />,
                <Button
                    key="onSubmit"
                    variant="primaryBrand"
                    text={isEdit ? 'ذخیره تغییرات' : 'ایجاد و فعال‌سازی'}
                    isDisabled={!canSubmit || isSubmitting}
                    isLoading={isSubmitting}
                    onClick={() => handleSubmit()}
                />,
            ]}
        >
            <div className="flex flex-col gap-16">
                <FormField label="عنوان *" alertMessage={localError && !title.trim() ? 'عنوان را وارد کنید' : ''} infoTipContent="عنوان - مثال: قوانین و مقررات سامانه گواهی دیجیتال">
                    <TextInput
                        fit="parent"
                        textAlign="right"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="مثال: قوانین و مقررات سامانه گواهی دیجیتال"
                    />
                </FormField>
                <FormField label="متن قوانین *" alertMessage={localError && !content.trim() ? 'متن قوانین را وارد کنید' : ''} infoTipContent="متن قوانین - متن کامل قوانین و مقررات...">
                    <TextArea
                        fit="parent"
                        rows={14}
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        placeholder="متن کامل قوانین و مقررات..."
                    />
                </FormField>
                {localError && <span className="body-s text-primaryAlert-default">{localError}</span>}
            </div>
        </Modal>
    );
};

export default TermsFormModal;